import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Alert, AlertTitle } from '@mui/material';

const StyledAlert = styled(Alert)`
  border-radius: 10px;

  & .MuiAlert-icon {
    align-items: flex-start;
    padding-top: 6px;
    font-size: 1.4em;
  }
`;

/**
 * Inline informational banner — the project-standard wrapper around MUI
 * `Alert`. Use for page-level notices (beta status, setup hints, warnings);
 * do not use raw `Alert` directly.
 */
const Callout = ({ children, icon, severity, sx, title, ...rest }) => {
  const iconNode = typeof icon === 'string' ? <span>{icon}</span> : icon;

  return (
    <StyledAlert icon={iconNode} severity={severity} sx={sx} {...rest}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </StyledAlert>
  );
};

Callout.defaultProps = {
  icon: undefined,
  severity: 'info',
  sx: undefined,
  title: undefined,
};

Callout.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
  severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  // `sx` is a pass-through property to Alert
  // eslint-disable-next-line react/forbid-prop-types
  sx: PropTypes.object,
  title: PropTypes.string,
};

export default Callout;
